/**
 * Máscara visual BR na UI — banco/API continuam só dígitos (hard rule).
 * Só formata nacional quando DDI é 55; outros DDI = só dígitos.
 */

export function digitsOnly(value: string): string {
  return value.replace(/\D+/g, "");
}

/** Formata número nacional BR: (11) 98888-7777 ou (11) 9888-7777. */
export function formatBrNationalPhone(digits: string): string {
  const d = digitsOnly(digits).slice(0, 11);
  if (d.length === 0) {
    return "";
  }
  if (d.length <= 2) {
    return `(${d}`;
  }
  if (d.length <= 6) {
    return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  }
  if (d.length <= 10) {
    return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  }
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

/** Valor do input de telefone conforme DDI (máscara só para 55). */
export function formatPhoneInput(countryCode: string, raw: string): string {
  const national = digitsOnly(raw).slice(0, 15);
  if (digitsOnly(countryCode) === "55") {
    return formatBrNationalPhone(national);
  }
  return national;
}

/** Exibição na tabela: +55 (11) 98888-7777 quando BR. */
export function formatPhoneListCell(
  countryCode: string | null | undefined,
  phoneNumber: string | null | undefined
): string {
  if (!phoneNumber) {
    return "—";
  }
  const cc = digitsOnly(countryCode || "55") || "55";
  const national = digitsOnly(phoneNumber);
  if (cc === "55") {
    return `+${cc} ${formatBrNationalPhone(national)}`;
  }
  return `+${cc} ${national}`;
}
